import { useQuery } from "@tanstack/react-query";
import { edifyPackagesGetEdifyPackages } from "@/usersAndProjects-client/sdk.gen";
import type { Package } from "../entities";

/**
 * Fetch all packages
 */
export interface UseFetchPackagesResult {
  packages: Package[] | null;
  isLoading: boolean;
  error: Error | null;
}

export const useFetchPackages = (options?: { enabled?: boolean }): UseFetchPackagesResult => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["packages"],
    queryFn: async () => {
      const response = await edifyPackagesGetEdifyPackages();
      // Validate response is an array, not HTML error page
      if (!Array.isArray(response.data)) {
        return [];
      }
      return response.data;
    },
    enabled: options?.enabled ?? true,
    staleTime: 10 * 60 * 1000, // Cache for 10 minutes
    retry: 2,
    refetchOnWindowFocus: false,
  });

  return {
    packages: data || null,
    isLoading,
    error: error as Error | null,
  };
};
